import { telemetryUrl } from './telemetry-privacy';

type PageViewParameters = {
  page_location: string;
  page_referrer: string;
  page_title: string;
};

/** One page view per path/query navigation, retaining only sanitized referrers. */
export function createGooglePageViewTracker() {
  let previousRoute: string | null = null;
  let previousLocation: string | null = null;

  return (href: string, referrer: string, title: string, send: (parameters: PageViewParameters) => void) => {
    const url = new URL(href);
    url.hash = '';
    const route = url.href;
    if (route === previousRoute) return false;
    const location = telemetryUrl(route);
    send({
      page_location: location,
      page_referrer: previousLocation ?? (referrer ? telemetryUrl(referrer) : ''),
      page_title: title,
    });
    previousRoute = route;
    previousLocation = location;
    return true;
  };
}
